import { Link } from "react-router-dom";
import { formatDate, formatTime } from "../util/api";

export default function DoctorTable({ appointments }) {

      const slideUp = {
        animation: "slideUp 0.8s ease-out",
    };

  const styles = {
    tableContainer: {
      display: "flex",
      flexDirection: "column",
      gap: "12px",
      padding: "20px",
      maxWidth: "1000px",
      margin: "0 auto",
    },
    card: {
      display: "flex",
      flexDirection: "column",
      background: "#fff",
      borderRadius: "12px",
      boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
      padding: "15px 20px",
      transition: "transform 0.2s, box-shadow 0.2s",
    },
    cardHover: {
      transform: "translateY(-5px)",
      boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
    },
    rowTop: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "8px",
      marginBottom: "10px",
    },
    rowBottom: {
      display: "flex",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: "8px",
      alignItems: "center",
    },
    badge: {
      padding: "3px 10px",
      borderRadius: "12px",
      fontSize: "12px",
      fontWeight: "bold",
      textTransform: "capitalize",
      color: "#fff",
    },
    statusConfirmed: {
      backgroundColor: "#4CAF50",
    },
    statusPending: {
      backgroundColor: "#FF9800",
    },
    statusCancelled: {
      backgroundColor: "#F44336",
    },
    btn: {
      textDecoration: "none",
      padding: "5px 12px",
      borderRadius: "8px",
      fontWeight: "bold",
      fontSize: "13px",
      color: "#fff",
      backgroundColor: "#007bff",
      transition: "background-color 0.2s",
    },
    btnHover: {
      backgroundColor: "#0056b3",
    },
    chatCount: {
      fontWeight: "bold",
      color: "red",
      marginLeft: "6px",
    },
    infoText: {
      fontSize: "14px",
      color: "#555",
      wordBreak: "break-word",
    },
  };

  return (
    <div style={styles.tableContainer}>
      {appointments.map((row, index) => (
        <div
          key={index}
          style={{ ...styles.card, ...slideUp }}
          className="doctor-card"
        >
          <div style={styles.rowTop}>
            <Link
              to={`/appointment/${row.id}`}
              style={styles.btn}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "#0056b3")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "#007bff")
              }
            >
              {row.status === "pending" ? "Make Payment" : "View"}
              {row.unseen_chat_box_count > 0 && (
                <span style={styles.chatCount}>
                  ✉️ ({row.unseen_chat_box_count})
                </span>
              )}
            </Link>

            <span style={styles.infoText}>{formatDate(row.created_at)}</span>
          </div>

          <div style={styles.rowBottom}>

            <div style={styles.infoText}>
              <strong>Appointment ID:</strong> {row.id || "N/A"}
            </div>


            <div style={styles.infoText}>
              <strong>Booked:</strong> {row.day} {formatTime(row.starttime)} -{" "}
              {formatTime(row.endtime)}
            </div>


            <div style={styles.infoText}>
              <strong>Patient:</strong> {row.patient.name || "N/A"}
            </div>
            <div
              style={{
                ...styles.badge,
                ...(row.status === "completed"
                  ? styles.statusConfirmed
                  : row.status === "pending"
                  ? styles.statusPending
                  : styles.statusCancelled),
              }}
            >
              {row.status}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
